export const GUEST_PATHS = ["/", "/login", "/cadastro/informacoes"];

export function isGuestRoute(to) {
  return GUEST_PATHS.some((p) => to.path === p || to.path.startsWith(p + "/"));
}
